import React, { useState } from "react"
import { Box, TextField, IconButton, Divider, Collapse } from "@material-ui/core"
import { Done as DoneIcon, Edit as EditIcon } from "@material-ui/icons"
import { preventDefault, useFormUtils } from "../../utils"
import { RowBox } from "../Boxes"
import { TASK_RESPONSE_TYPE } from "../../data"

const { NUMBER, TEXT } = TASK_RESPONSE_TYPE

const OutlinedInputStep = ({
  expand,
  inputRef,
  complete,
  step: { responseType },
  onResponseChange,
  onCompletedChange,
  isScheduled,
  value,
  classes,
}) => {
  const { validate } = useFormUtils()
  const [valid, setValid] = useState(true)

  const handleResponseChange = (event) => {
    const { value: newValue } = event.target

    if (responseType === NUMBER) {
      setValid(validate.requiredNumeric(newValue))
    }
    if (responseType === TEXT) {
      setValid(validate.required(newValue))
    }

    onResponseChange && onResponseChange(event)
  }

  const handleCompletedChange = (event) => {
    onCompletedChange && onCompletedChange(event)
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && valid) {
      handleCompletedChange(event)
    }
  }

  return (
    <Collapse in={expand}>
      <Divider className={classes.divider} />

      <RowBox p={2}>
        <TextField
          label="Answer"
          placeholder={responseType === NUMBER ? "Enter number" : "Enter text"}
          inputRef={inputRef}
          variant="outlined"
          type="text"
          value={value || ""}
          onClick={preventDefault}
          onChange={handleResponseChange}
          onKeyDown={handleKeyDown}
          inputProps={{
            className: complete ? classes.completedText : null,
            inputMode: responseType === NUMBER ? "decimal" : "text",
          }}
          fullWidth
          disabled={complete || isScheduled}
          multiline={complete}
          data-cy={`ProcessStep-field-${responseType}`}
        />
        <Box ml={1}>
          {!complete && (
            <Box onClick={preventDefault}>
              <IconButton
                onClick={handleCompletedChange}
                disabled={!value || !valid || isScheduled}
                className={classes.incompletedButton}
                data-cy={`ProcessStep-field-${responseType}-complete`}
              >
                <DoneIcon />
              </IconButton>
            </Box>
          )}
          {complete && (
            <IconButton
              onClick={handleCompletedChange}
              className={classes.completedButton}
              disabled={isScheduled}
              data-cy={`ProcessStep-field-${responseType}-uncomplete`}
            >
              <EditIcon />
            </IconButton>
          )}
        </Box>
      </RowBox>
    </Collapse>
  )
}

export { OutlinedInputStep }
